import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nProvider } from './i18n';
import { AppContextProvider } from './components/context';
import { KeycloackContextProvider } from "./services/keycloakProvider"
import { SessionContextProvider } from './services/SessionProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SessionContextProvider>
    <KeycloackContextProvider>
      <AppContextProvider>
        <I18nProvider>
          <App/>
        </I18nProvider>
      </AppContextProvider>
    </KeycloackContextProvider>
  </SessionContextProvider>
);